document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidad();
});

function formatearDinero(centavos) {
  return (centavos / 100).toLocaleString(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  });
}

function initReveal() {
  var elementos = document.querySelectorAll('.jy-reveal');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('jy-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('jy-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  elementos.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-jy-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-jy-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-jy-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        if (!full) return;
        principal.src = full;
        miniaturas.forEach(function (m) { m.classList.remove('is-active'); });
        mini.classList.add('is-active');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-jy-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-jy-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('[data-jy-variant-id]');
    var precioEl = form.querySelector('[data-jy-precio]');
    var precioAntesEl = form.querySelector('[data-jy-precio-antes]');
    var botonComprar = form.querySelector('[data-jy-add-boton]');
    var swatches = form.querySelectorAll('[data-jy-swatch]');
    if (!swatches.length) return;

    var scope = form.closest('.jy-section') || form;
    var imagenPrincipal = scope.querySelector('[data-jy-imagen-principal]');
    var miniaturas = scope.querySelectorAll('[data-jy-miniatura]');

    function aplicarVariante(variante) {
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      form.dataset.precioUnidad = variante.price;
      form.dispatchEvent(new CustomEvent('jy:precio-actualizado'));
      if (precioEl) precioEl.textContent = formatearDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatearDinero(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
      swatches.forEach(function (sw) {
        sw.classList.toggle('is-active', sw.getAttribute('data-valor') === variante.option1);
      });
      if (imagenPrincipal && variante.imagen) {
        imagenPrincipal.src = variante.imagen;
        miniaturas.forEach(function (mini) {
          mini.classList.toggle('is-active', mini.getAttribute('data-full') === variante.imagen);
        });
      }
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var valor = sw.getAttribute('data-valor');
        var variante = variantes.find(function (v) { return v.option1 === valor; });
        aplicarVariante(variante);
      });
    });
  });
}

function initCantidad() {
  document.querySelectorAll('[data-jy-producto-form]').forEach(function (form) {
    var botones = form.querySelectorAll('[data-jy-cantidad]');
    var inputCantidad = form.querySelector('[data-jy-cantidad-input]');
    if (!botones.length || !inputCantidad) return;

    var infoPaquete = form.querySelector('[data-jy-bundle-info]');
    var precioPaqueteEl = form.querySelector('[data-jy-bundle-precio]');
    var precioPaqueteAntesEl = form.querySelector('[data-jy-bundle-antes]');
    var ahorroPaqueteEl = form.querySelector('[data-jy-bundle-ahorro]');

    function precioUnidadActual() {
      return parseInt(form.dataset.precioUnidad, 10) || 0;
    }

    function actualizarPaquete() {
      var unidad = precioUnidadActual();
      if (!unidad) return;
      var totalSinDescuento = unidad * 2;
      var descuentoSegundaUnidad = Math.floor(unidad * 0.5);
      var segundaUnidadConDescuento = unidad - descuentoSegundaUnidad;
      var totalConDescuento = unidad + segundaUnidadConDescuento;
      if (precioPaqueteEl) precioPaqueteEl.textContent = formatearDinero(totalConDescuento);
      if (precioPaqueteAntesEl) precioPaqueteAntesEl.textContent = formatearDinero(totalSinDescuento);
      if (ahorroPaqueteEl) ahorroPaqueteEl.textContent = formatearDinero(totalSinDescuento - totalConDescuento);
    }

    // Color de la 2ª unidad: permite llevar 2 almohadas de colores distintos
    var segundoColor = form.querySelector('[data-jy-segundo-color]');
    var swatches2 = form.querySelectorAll('[data-jy-swatch-2]');
    var inputId = form.querySelector('[data-jy-variant-id]');
    var variantes = [];
    var dataEl = form.querySelector('[data-jy-variantes-json]');
    if (dataEl) {
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { variantes = []; }
    }
    var segundaVariante = variantes.find(function (v) { return inputId && String(v.id) === String(inputId.value); }) || null;
    var segundoTocado = false;

    var scope = form.closest('.jy-section') || form;
    var imagenPrincipal = scope.querySelector('[data-jy-imagen-principal]');
    var miniaturas = scope.querySelectorAll('[data-jy-miniatura]');

    function marcarSegunda(variante, mostrarImagen) {
      if (!variante) return;
      segundaVariante = variante;
      swatches2.forEach(function (sw) {
        sw.classList.toggle('is-active', sw.getAttribute('data-valor') === variante.option1);
      });
      if (mostrarImagen && imagenPrincipal && variante.imagen) {
        imagenPrincipal.src = variante.imagen;
        miniaturas.forEach(function (mini) {
          mini.classList.toggle('is-active', mini.getAttribute('data-full') === variante.imagen);
        });
      }
    }

    swatches2.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var valor = sw.getAttribute('data-valor');
        segundoTocado = true;
        marcarSegunda(variantes.find(function (v) { return v.option1 === valor; }), true);
      });
    });

    // Mientras el cliente no elija otro color para la 2ª, sigue al de la 1ª
    form.addEventListener('jy:precio-actualizado', function () {
      if (segundoTocado || !inputId) return;
      marcarSegunda(variantes.find(function (v) { return String(v.id) === String(inputId.value); }), false);
    });

    form.addEventListener('submit', function (evento) {
      if (inputCantidad.value !== '2' || !segundaVariante || !inputId) return;
      if (String(segundaVariante.id) === String(inputId.value)) return; // mismo color: envío normal
      evento.preventDefault();
      var botonComprar = form.querySelector('[data-jy-add-boton]');
      if (botonComprar) botonComprar.disabled = true;
      var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(inputId.value), quantity: 1 },
            { id: Number(segundaVariante.id), quantity: 1 }
          ]
        })
      })
        .then(function (respuesta) {
          return respuesta.json().then(function (datos) {
            if (!respuesta.ok) throw new Error(datos.description || datos.message || 'Error');
            window.location.href = raiz + 'cart';
          });
        })
        .catch(function (error) {
          if (botonComprar) botonComprar.disabled = false;
          alert(error.message);
        });
    });

    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var cantidad = boton.getAttribute('data-jy-cantidad');
        inputCantidad.value = cantidad;
        botones.forEach(function (b) { b.classList.toggle('is-active', b === boton); });
        if (infoPaquete) infoPaquete.style.display = cantidad === '2' ? '' : 'none';
        if (segundoColor) segundoColor.style.display = cantidad === '2' ? '' : 'none';
      });
    });

    form.addEventListener('jy:precio-actualizado', actualizarPaquete);
    actualizarPaquete();
  });
}
